import React from 'react';

function SchoolInfoCard({
  schools = [],
  schoolVisibleCount = 6,
  schoolLoadingMore = false,
  onLoadMoreSchool,
}) {
  return (
    <section className="overview-card fixed-height-card">
      <h3>{'\uCD08\uB4F1\uD559\uAD50'}</h3>
      {schools.length ? (
        <>
          <div className="card-list-scroll">
            <ul className="bullet-list">
              {schools.slice(0, schoolVisibleCount).map((item, idx) => (
                <li key={`school-${idx}`}>
                  {item.schoolName || '-'}
                  {item.operationType ? ` · ${item.operationType}` : ''}
                  {item.distance ? ` · ${item.distance.toLocaleString()}m` : ''}
                  {item.walkingMinute ? ` · 도보 ${item.walkingMinute}분` : ''}
                </li>
              ))}
            </ul>
          </div>
          {schools.length > schoolVisibleCount ? (
            <button type="button" className="more-btn" onClick={onLoadMoreSchool} disabled={schoolLoadingMore}>
              {schoolLoadingMore ? '\uB85C\uB529 \uC911..' : '\uB354\uBCF4\uAE30'}
            </button>
          ) : null}
        </>
      ) : (
        <p className="empty-mini">{'\uB370\uC774\uD130 \uC5C6\uC74C'}</p>
      )}
    </section>
  );
}

export default SchoolInfoCard;
